import script from "./Editor.vue?vue&type=script&setup=true&lang=js"
export * from "./Editor.vue?vue&type=script&setup=true&lang=js"

import "./Editor.vue?vue&type=style&index=0&id=41de80bc&scoped=true&lang=css"
import "./Editor.vue?vue&type=style&index=1&id=41de80bc&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41de80bc"]])

export default __exports__